import { render, staticRenderFns } from "./ErrorMessage.htm?vue&type=template&id=2a523d1a&scoped=true&"
var script = {}
import style0 from "./ErrorMessage.scss?vue&type=style&index=0&id=2a523d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a523d1a",
  null
  
)

export default component.exports